import IWall from 'components/interfaces/IWall';

const calculateGlassLineLength = (
  wall: IWall
): {
  glassEndPoint: number;
  glassStartPoint: number;
  totalGlassLength: number;
} => {
  const { glassEndPoint, glassStartPoint, totalGlassLength } =
    window.CalculateGlassLineLength({
      glazingWallType: wall.glazingWallType,
      positionOffset: -wall.positionOffset,
      glassType: wall.glassType,
      doorSide: wall.doorSide,
      aluGlazyFloorProfileType: wall.aluGlazyFloorProfileType,
      aluGlazyRoofProfileType: wall.aluGlazyRoofProfileType,
      leftVerticalProfileType: wall.leftVerticalProfileType,
      rightVerticalProfileType: wall.rightVerticalProfileType,
      leftWallOffset: wall.leftWallOffset,
      rightWallOffset: wall.rightWallOffset,
      woodyIncludeWoodyLeftProfile: wall.woodyIncludeWoodyLeftProfile,
      woodyIncludeWoodyRightProfile: wall.woodyIncludeWoodyRightProfile,
    });
  return {
    glassEndPoint,
    glassStartPoint,
    totalGlassLength,
  };
};

export default calculateGlassLineLength;
